import { ListingType, PropertyType } from '@zg-rentals/ts-rental-manager-api-client';

export const LISTING_TYPES = {
  RENTAL: 'For Rent',
  ROOM: 'Room for Rent',
  SALE: 'For Sale',
} as const;

export const PROPERTY_TYPES = {
  COMMUNITY: 'Entire apartment community',
  CONDO: 'Apartment unit/Condo',
  MULTIPLEX: 'Apartment units',
  HOUSE: 'House',
  TOWNHOUSE: 'Townhome',
} as const;

export type ListingTypeLabel = (typeof LISTING_TYPES)[keyof typeof LISTING_TYPES];
export type PropertyTypeLabel = (typeof PROPERTY_TYPES)[keyof typeof PROPERTY_TYPES];

const { RENTAL, ROOM, SALE } = LISTING_TYPES;
const { COMMUNITY, CONDO, HOUSE, MULTIPLEX, TOWNHOUSE } = PROPERTY_TYPES;

export const LISTING_TYPE_TO_ENUM: Record<ListingTypeLabel, ListingType> = {
  [RENTAL]: ListingType.RENTAL,
  [ROOM]: ListingType.ROOM,
  [SALE]: ListingType.SALE,
};

// Community maps to LARGE as the general-purpose community PropertyType
export const PROPERTY_TYPE_TO_ENUM: Record<string, PropertyType> = {
  [COMMUNITY]: PropertyType.LARGE,
  [CONDO]: PropertyType.CONDO,
  [MULTIPLEX]: PropertyType.CONDO,
  [HOUSE]: PropertyType.HOUSE,
  [TOWNHOUSE]: PropertyType.TOWNHOUSE,
};

export const PROPERTY_TYPES_BY_ENUM: Record<string, string> = {
  CONDO: CONDO,
  DIVIDED: COMMUNITY,
  GARDEN: COMMUNITY,
  HOUSE: HOUSE,
  LARGE: COMMUNITY,
  MEDIUM: COMMUNITY,
  TOWNHOUSE: TOWNHOUSE,
};
export const SINGLE_CONDO_LABEL = 'Condo';

export const PROPERTY_CODES_BY_TYPE = {
  [COMMUNITY]: 1,
  [CONDO]: 5,
  [HOUSE]: 6,
  [MULTIPLEX]: 5,
  [TOWNHOUSE]: 7,
} as const;
